var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 19,
    viewBox: "0 0 8 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.997 6.38044V4.93444C4.997 4.71644 5.007 4.54844 5.027 4.42944C5.04829 4.30558 5.09273 4.18684 5.158 4.07944C5.19473 4.01908 5.24308 3.96661 5.30024 3.92506C5.35741 3.88352 5.42224 3.85374 5.491 3.83744C5.69074 3.78794 5.89632 3.76607 6.102 3.77244H7.491V0.877441H5.271C3.986 0.877441 3.064 1.19544 2.503 1.82944C1.943 2.46644 1.663 3.40144 1.663 4.63744V6.38044H0V9.27544H1.662V17.6754H4.997V9.27544H7.217L7.51 6.38044H4.997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f786a5af85e9e99eaf12873d8919e85c.svg";
export { ForwardRef as ReactComponent };